export default {
  确认: "確認",
  取消: "取消",
  选择语言: "選擇語言",
  切换语言成功: "切換語言成功",
  首页: "首頁",
  报单: "報單",
  团队: "團隊",
  "交易进行中,请勿进行其他操作": "交易進行中,請勿進行其他操作",
  资金管理: "資金管理",
  资金明细: "資金明細",
  我的订单: "我的訂單",
  订单详情: "訂單詳情",
  没有更多了: "沒有更多了",
  加载中: "加載中",
  代币价格: "代幣價格",
  收益概览: "收益概覽",
  申购收益: "申購收益",
  分享收益: "分享收益",
  官方网站: "官方網站",
  官网: "官網",
  电报: "電報",
  推特: "推特",
  白皮书: "白皮書",
  申购金额: "申購金額",
  请输入入金金额: "請輸入入金金額",
  快捷申购: "快捷申購",
  申购比例: "申購比例",
  赠币数量: "贈幣數量",
  立即申购: "立即申購",
  更多: "更多",
  订单: "訂單",
  分红中: "分紅中",
  已完成: "已完成",
  累计分红: "累計分紅",
  申购信息: "申購信息",
  兑换数量: "兌換數量",
  赠币数量: "贈幣數量",
  开始时间: "開始時間",
  提现成功: "提現成功",
  确认: "確認",
  订单编号: "訂單編號",
  团队数据总览: "團隊數據總覽",
  我的推广链接: "我的推廣鏈接",
  复制: "複製",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "分享此鏈接邀請好友加入團隊，獲取推廣獎勵",
  团队业绩: "團隊業績",
  当前等级: "當前等級",
  今日收益: "今日收益",
  申购收益: "申購收益",
  分享收益: "分享收益",
  团队用户: "團隊用戶",
  有效团队: "有效團隊",
  有效用户: "有效用戶",
  无效团队: "無效團隊",
  直推用户: "直推用戶",
  有效直推: "有效直推",
  无效直推: "無效直推",
  资产余额数据概览: "資產餘額數據概覽",
  提现: "提現",
  选中币种: "選中幣種",
  请输入入金金额: "請輸入入金金額",
  提现数量: "提現數量",
  确认提现: "確認提現",
  资金明细: "資金明細",
  分红收入: "分紅收入",
  直推奖励: "直推獎勵",
  团队奖励: "團隊獎勵",
  申购金额: "申購金額",
  兑换数量: "兌換數量",
  赠币数量: "贈幣數量",
  开始时间: "開始時間",
  立即申购: "立即申購",
  确认: "確認",
  全部: "全部",
  收入: "收入",
  支出: "支出",
  请输入正确的金额: "請輸入正確的金額",
  申购成功: "申購成功",
  申购失败: "申購失敗",
  提现失败: "提現失敗",
  提现信息: "提現信息",
  提现币种: "提現幣種",
  提现数量: "提現數量",
  请选择币种: "請選擇幣種",
  钱包余额不足: "錢包餘額不足",
  余额不足: "餘額不足",
  提现手续费: "提現手續費",
  间推奖励: "間推獎勵",
  团队奖励: "團隊獎勵",
  提现失败退还: "提現失敗退還",
  ido申购: "ido申購",
  ido申购赠送: "ido申購贈送",
  链式去中心化全球点火网络: "鏈式去中心化全球點火網絡",
  协议永生: "協議永生",
  智能涌现: "智能湧現",
  财富觉醒: "財富覺醒",
  立即进入: "立即進入",
  大区累计业绩: "大區累計業績",
  小区累计业绩: "小區累計業績",
  复制成功: "複製成功",
  复制失败: "複製失敗",
  暂无数据: "暫無數據",
  当DeFi遇上自主型DAO: "當DeFi遇上自主型DAO",
  历史最高: "歷史最高",
  历史最低: "歷史最低",
  当前价格: "當前價格",
  报单累计收益: "報單累計收益",
  团队累计收益: "團隊累計收益",
  报单金额: "報單金額",
  快捷报单: "快捷報單",
  请输入报单金额: "請輸入報單金額",
  报单比例: "報單比例",
  报单信息: "報單信息",
  进行中: "進行中",
  已完成: "已完成",
  累计收益: "累計收益",
  立即报单: "立即報單",
  请输入提现数量: "請輸入提現數量",
  提现确认: "提現確認",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "本次提現的鏈上Gas費需由您自行承擔，點擊確定將執行提現流程，屆時提取的餘額會被優先扣除",
  "操作后无法撤销，请谨慎认购": "操作後無法撤銷，請謹慎認購",
  我再想想: "我再想想",
  确认提现: "確認提現",
  余额不足: "餘額不足",
  直推奖励: "直推獎勵",
  团队奖励: "團隊獎勵",
  提现失败退还: "提現失敗退還",
  平级收益: "平級收益",
  每日释放: "每日釋放",
  提现JCT: "提現JCT",
  报单失败: "報單失敗",
  绑定邀请人: "綁定邀請人",
  报单成功: "報單成功",
  提现比例: "提現比例",
  入金支付说明: "入金支付說明",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "您的實際支付由兩部分組成，根據當前支付比例計算",
  支付JCT数量: "支付JCT數量",
  入金数量: "入金數量",
  JCT支付比例: "JCT支付比例",
  "注：支付比例由平台设定，可能随时调整":
    "註：支付比例由平台設定，可能隨時調整",
  我知道了: "我知道了",
  支付USDT数量: "支付USDT數量",
  USDT支付比例: "USDT支付比例",
  JCT实时价格: "JCT實時價格",
  请先连接TCC链: "請先連接TCC鏈",
  CUSD支付比例: "CUSD支付比例",
  支付CUSD数量: "支付CUSD數量",
  算力红利: "算力红利",
  "当DeFi遇上自主型DAO闲置算力共享": "當DeFi遇上自主型DAO闲置算力共享",
  "全民节点分红智能涌现": "全民節分红智能湧現",
  "闲置算力共享·全民节点分红": "闲置算力共享·全民節分红",
};
